export default __webpack_public_path__ + "static/media/english.2bc729ce.png";